import extendedTablesStyle from '../../../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx'
export default theme => ({
  ...extendedTablesStyle,
  dialogPaper: {
    minHeight: '600px',
    // maxHeight: '600px',
    maxWidth: '1100px'
  }
})
